import { useEffect, useRef, useState } from "react";
import { t } from "@/i18n-js/instance";
import { LoadingIndicator } from "./LoadingIndicator";

const CLOSING_SECONDS = 15;

interface ClosingIndicatorProps {
  roomType: string;
}

export const ClosingIndicator = ({ roomType }: ClosingIndicatorProps) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [seconds, setSeconds] = useState(CLOSING_SECONDS);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setSeconds(Math.max(seconds - 1, 0));
      timeoutRef.current = null;
    }, 1000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [seconds]);

  const label = seconds
    ? t(`live_streams.room.${roomType}.closing`, { seconds })
    : t(`live_streams.room.${roomType}.closing_now`);

  return <LoadingIndicator label={label} />;
};
